import { action, observable } from 'mobx';
import Alert from 'react-s-alert';

import { AppManager, Input, routerStore } from 'core';

import { FormStore } from 'libs/forms/app';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { conf as inviteConf } from 'apps/profile/accessForm/inviteConfig.yaml';
import { conf } from 'apps/profile/accessForm/config.yaml';
import { SignUpRequestMutation } from 'apps/group/gql';

export class AccessFormAppManager extends AppManager {
  static registryName = 'AccessFormAppManager';
  @observable username = '';
  @observable email = '';
  @observable password = '';
  @observable bio = '';
  @observable sent = false;
  constructor(parent, init = {}) {
    super(parent, init);
    const formConf = INVITE_MODE ? inviteConf : conf;
    this.form = new FormStore(this, formConf, 'accessForm', '', init.autoFocus);
    if (INVITE_MODE) {
      this.inviteRequestInput = new Input({
        email: () => this.email,
        bio: () => this.bio,
      });
    }
  }

  @action Submit = () => {
    if (this.form.isValid) {
      if (INVITE_MODE) {
        this.form.SetPosting(true);
        clientStore.SetPosting(true);
        this.mutations.push(
          SignUpRequestMutation.New(this.inviteRequestInput, {
            onSysErr: this.onError,
            onUserErr: this.onError,
            onSuccess: this.onSubmitSuccess,
          }),
        );
      } else {
        routerStore.navigate('home.signUp', {
          username: this.username,
          email: this.email,
          password: this.password,
        });
        this.password = '';
      }
    } else {
      this.form.alert();
    }
  };

  @action onSubmitSuccess = result => {
    this.form.SetPosting(false);
    this.form.clearDraft();
    clientStore.SetPosting(false);
    if (result.requestInvite.result === 'ok') {
      Alert.success("Received. We'll get back to you asap.");
      this.email = '';
      this.bio = '';
      this.sent = true;
    } else if (result.requestInvite.result === 'existing') {
      this.email = '';
      Alert.error(
        'Hmm. Looks like you already requested an invite with this email.',
      );
    }
    modalStore.ClearComponent();
  };

  @action onError = () => {
    Alert.error('Hmm... Something went wrong, please try again.');
    this.form.SetPosting(false);
    clientStore.SetPosting(false);
  };
}
